module.exports = __webpack_public_path__ + "static/media/ramadhan_sweets.5900ae7d.jpeg";